import { NavigationState } from "@shared/models/navigation-state";
export class ActivateUserNavigationState extends NavigationState {
	readonly className = "ActivateUserNavigationState";
	email?: string;
}
